import React, { createRef, useReducer, useRef } from "react";
import PageLayout from "../PageLayout/PageLayout";
import PrivacySettings from "./PrivacySettings/PrivacySettings";
import PayoutMethods from "./PayoutMethods/PayoutMethods";
import Notifications from "./Notifications/Notifications";
import { useSelector } from "react-redux";

export default function ProfileSettings() {
  const activeTab = useSelector((state) => state.commonReducer.activeTab);

  return (
    <>
      <PageLayout>
        {(activeTab == "privacy-settings" && <PrivacySettings />) ||
          (activeTab == "payout-methods" && <PayoutMethods />) ||
          (activeTab == "notifications" && <Notifications />)}
      </PageLayout>
    </>
  );
}
